export interface VerticalNavLink {
    label: string;
    href: string;
    external?: boolean;
    disabled?: boolean;
}

export interface VerticalNavProps {
    links?: VerticalNavLink[];
    onClose?: () => void;
}

// Styles object
export const verticalNavStyles = {
    list: {
        width: '170px',
        pl: '17px',
    },
    listItemButton: {
        py: 0.5,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'transparent',
        textDecoration: 'none',
        transition: 'background-color 0.2s, border-left 0.2s',
        borderLeft: '1px solid #D2DBDE',
        '&:hover': {
            backgroundColor: 'rgba(223, 253, 249, 0.4)',
            borderLeft: '2px solid #8FE9E3',
        },
    },
    listItemText: {
        margin: 0,
        fontFamily: 'Red Hat Text',
        color: '#47515A',
        fontSize: '14px',
        fontWeight: 400,
        display: 'flex',
        flexGrow: 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    iconBox: {
        ml: 1,
        flexShrink: 0,
    },
    icon: {
        color: '#8499A0',
    },
};
